import { Grid, Paper } from "@mui/material";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";

import "./index.css";
import TableAbsences from "./TableAnsences";
import { COUPONS_TO_MY_CHARGE_HISTORY_THREE } from "../../../constants/signalRequestConsts";
import { searchCouponsToMyChargeEmployeesHistory } from "../../../store/slices/userRequests";
import MySnackbar from "../../../components/MySnackbar";
import MySelectCompany from "../../../components/MySelectCompany";

// 0: todos los tipos de cupones
// -1: solo vacaciones sunat
// -2: todo menos vacaciones sunat
// const couponId = "-2"

const ManagementAbsences = ({couponId,}: {couponId: string,}) => {

    const dispatch = useDispatch<AppDispatch>();
    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const [rucSelected, setRucSelected] = useState<string>("")
    const [status, setStatus] = useState<string>("-2")
    // const [orderedEmployees, setOrderedEmployees] = useState<{ [key: string]: Employee[] }>({})
    const [errorMsg, setErrorMsg] = useState<string>("");

    
    const getInitialCouponsData = async () => {
        dispatch(searchCouponsToMyChargeEmployeesHistory(
            COUPONS_TO_MY_CHARGE_HISTORY_THREE, 
            status,
            couponId,
        ));
    }

    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected) {
            return;
        }
        getInitialCouponsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rucSelected, status]);


    return (
    <Grid item width="100%" marginTop="1.5rem" minHeight="100%">
        <Paper
            elevation={3}
            style={{
                width: "100%", 
                borderRadius: "0.5rem",
                minHeight: "10rem",
                padding: "2rem 1.5rem"
            }}
        >
            
            <MySelectCompany
                setRucSelected={setRucSelected} 
                rucSelected={rucSelected}
                includeAllCompaniesOption={true}
                allCompaniesOptionValue={'all'}
            />
            <TableAbsences 
                rucEmpresa={rucSelected} 
                requestId={COUPONS_TO_MY_CHARGE_HISTORY_THREE}
                hiddenFilterOptions={false}
                allowApproveOptions={false}
                statusValue={status}
                setStatusValue={setStatus}
            />
        </Paper>
        <MySnackbar
            open={errorMsg !== ""}
            autoHideDuration={6000}
            msg={errorMsg}
            severity="error"
            onClose={() => setErrorMsg("")} 
        />
    </Grid>)
}

export default ManagementAbsences;